"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyPagesLayoutFeature = void 0;
var _default = require("../default");
// Add more if needed
const MyPagesLayoutFeature = exports.MyPagesLayoutFeature = {
  ..._default.DefaultLayoutFeature
};
